import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Pre/Post Checkout",
    subheader:
      "Control the user experience before and after checkout, including digital content delivery."
  }),
  rows: [
    {
      title: {
        value: "Custom redirects",
        tooltip: "Set the success and cancel urls for each checkout session."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: true
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Digital content",
        tooltip: "Deliver a digital asset to a customer after purchase."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Upsells",
        tooltip: "Configure post purchase product upsells."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: true
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true,
        value: "Coming soon"
      }
    },
    {
      title: {
        value: "Custom form fields",
        tooltip:
          "Add custom form fields to capture additional customer input within checkout."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true,
        value: "Coming soon"
      }
    }
  ]
};
